var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4152 20.7806L4.93519 14.0306C4.80012 13.8899 4.72418 13.699 4.72418 13.5C4.72418 13.301 4.80012 13.1101 4.93519 12.9694C5.07026 12.8286 5.25353 12.7496 5.44457 12.7496C5.6357 12.7496 5.81887 12.8286 5.95404 12.9694L11.2046 18.4397V3.75C11.2046 3.55109 11.2805 3.36032 11.4155 3.21967C11.5506 3.07902 11.7336 3 11.9246 3C12.1155 3 12.2987 3.07902 12.4338 3.21967C12.5687 3.36032 12.6446 3.55109 12.6446 3.75V18.4397L17.8952 12.9694C18.0303 12.8286 18.2135 12.7496 18.4046 12.7496C18.5957 12.7496 18.7789 12.8286 18.914 12.9694C19.0491 13.1101 19.125 13.301 19.125 13.5C19.125 13.699 19.0491 13.8899 18.914 14.0306L12.434 20.7806C12.3671 20.8504 12.2877 20.9057 12.2003 20.9434C12.1129 20.9812 12.0192 21.0006 11.9246 21.0006C11.83 21.0006 11.7363 20.9812 11.6489 20.9434C11.5615 20.9057 11.4821 20.8504 11.4152 20.7806Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/_arrow-down.a42309d695430b870c1339c02e37d7b8.svg";
export { ForwardRef as ReactComponent };